import React, { useEffect } from 'react';

const LegalContent = ({ kicker, meta, sections }) => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<section className="legal-page">
			<div className="container">
				<div className="legal-page__wrap">
					{kicker ? <p className="legal-page__kicker">{kicker}</p> : null}
					{meta ? <p className="legal-page__meta">{meta}</p> : null}
					{sections.map((section) => (
						<div className="legal-page__section" id={section.id} key={section.id}>
							<h2>{section.title}</h2>
							{section.paragraphs && section.paragraphs.map((paragraph, index) => (
								<p key={index}>{paragraph}</p>
							))}
							{section.list && (
								<ul>
									{section.list.map((item, index) => (
										<li key={index}>{item}</li>
									))}
								</ul>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default LegalContent;
